import { render } from "./ModalDigitalPaymentSummary.vue?vue&type=template&id=cbd78cde&scoped=true"
import script from "./ModalDigitalPaymentSummary.vue?vue&type=script&lang=js"
export * from "./ModalDigitalPaymentSummary.vue?vue&type=script&lang=js"

import "./ModalDigitalPaymentSummary.vue?vue&type=style&index=0&id=cbd78cde&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd78cde"]])

export default __exports__